var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Fill-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#202020",
    transform: "translate(12.000000, 7.000000) rotate(-90.000000) translate(-12.000000, -7.000000) ",
    points: "10.0035587 2 9 3.00540136 12.9822064 6.99973261 9 10.9945986 10.0035587 12 15 6.99973261"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1-Copy",
    fill: "#202020",
    transform: "translate(12.000000, 17.000000) rotate(-270.000000) translate(-12.000000, -17.000000) ",
    points: "10.0035587 12 9 13.0054014 12.9822064 16.9997326 9 20.9945986 10.0035587 22 15 16.9997326"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortIc);
export default __webpack_public_path__ + "static/media/sort_ic.e129db0b.svg";
export { ForwardRef as ReactComponent };